import { useLocation } from 'react-router-dom';
import { ChannelsTab, ChannelsTabType } from './ChannelsTabs.constants';

const useChannelsActiveTab = (): ChannelsTabType => {
  const { pathname } = useLocation();

  const defaultTab = ChannelsTab.directChannels;

  return (
    Object.values(ChannelsTab).find((tab) => pathname.endsWith(`/${tab}`)) ??
    defaultTab
  );
};

export default useChannelsActiveTab;
